import { render, staticRenderFns } from "./ControleAssinatura.vue?vue&type=template&id=144a5320&scoped=true&"
import script from "./ControleAssinatura.vue?vue&type=script&lang=js&"
export * from "./ControleAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./ControleAssinatura.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ControleAssinatura.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ControleAssinatura.vue?vue&type=style&index=2&id=144a5320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a5320",
  null
  
)

export default component.exports